import { compose } from "recompose";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import RegionsIndex from "components/Regions/RegionsIndex";

const mapStateToProps = state => {
  const { firestore, firebase } = state;

  const regions = firestore.ordered.regions;
  const auth = firebase.auth;

  const isLoading = !isLoaded(regions);
  const isDataEmpty = isEmpty(regions);

  return {
    isLoading: isLoading,
    isEmpty: isDataEmpty,
    regions: regions && regions.filter(obj => !obj.system),
    auth: auth,
  };
};

export default compose(
  firestoreConnect([{ collection: "regions", orderBy: ["createdAt", "desc"] }]),
  connect(mapStateToProps)
)(RegionsIndex);
